<script lang="ts">
    import { setContext } from 'svelte'
    import type ServiceProvider from '../services/service.provider'
    import Pager from '../../../components/Pager.svelte'

    export let serviceProvider: ServiceProvider

    let displayPager = false
    let total = 0
    let page = 0
    let perPage = 0

    const setPage = (page: number): void => {
        serviceProvider.searchService.goToPage(page)
    }

    const setPageSize = (pageSize: number): void => {
        perPage = pageSize
        serviceProvider.searchService.changePageSize(pageSize)
    }

    serviceProvider.searchService.pagerSubs.subscribe((state) => {
        total = state.total
        page = state.page
        perPage = state.perPage
        displayPager = true
    })

    setContext('pager', {
        total,
        page,
        perPage,
        setPage,
        setPageSize,
    })
</script>

{#if displayPager}
    <Pager/>
{/if}
